import React, { useState, useEffect } from 'react'
import get from 'lodash/get'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import Loading from 'Components/loading'

interface ICarItem {
  info: any
  type: number
}
interface ICar {
  name: string
  data: ICarItem[]
}
interface IProp {
  show?: boolean
  style?: React.CSSProperties
  seriesId?: number
  onChange: (id: number, name: string, year: number, price: string) => void
}

const Car = ({ seriesId, onChange, show = false, style = {} }: IProp) => {
  const [car, setCar] = useState<ICar[]>([])
  const [loading, setLoading] = useState(false)
  const [empty, setEmpty] = useState(false)
  useEffect(() => {
    if (!seriesId) return
    fetchCar()
  }, [seriesId])
  // 获取品牌数据
  function fetchCar() {
    if (!seriesId) return
    setLoading(true)
    fetch(getUrl(`/motor/garage/get_cars_by_series_id/${seriesId}/?no_sales=1`))
      .then((res) => {
        setLoading(false)
        const list = get(res, 'data.list', [])
        if (list.length === 0) {
          setEmpty(true)
          return
        }
        if (res.message === 'success') {
          const carList: ICar[] = []
          list.forEach((item: any) => {
            const car = { name: item.name, data: [] }
            get(item, 'data', []).forEach((item2: any) => {
              car.data = car.data.concat(item2.data)
            })
            carList.push(car)
          })
          setCar(carList)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  if (!show || !seriesId) return null
  return (
    <section className="car-selector g-hover-scroll-bar" style={style}>
      {loading && <Loading />}
      {car.map((item: ICar) => (
        <div key={item.name}>
          {item.data.map((item2) => (
            <p
              className="item-wrap"
              key={item2.info.id}
              onClick={(e) => {
                e.stopPropagation()
                onChange(
                  item2.info.id,
                  item2.info.name,
                  item2?.info?.year,
                  item2?.info?.official_price
                )
              }}
            >
              <span className="name">{`${item2?.info?.year}款 ${item2.info.name}`}</span>
              <span className="price">{item2?.info?.official_price}</span>
            </p>
          ))}
        </div>
      ))}
      <style jsx>
        {`
          section {
            position: fixed;
            top: 120%;
            right: 0;
            width: 260px;
            max-height: 432px;
            background-color: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            overflow: auto;
            transform: translateZ(0);
            -webkit-overscroll-behavior: none;
          }
          h4 {
            position: sticky;
            top: 0;
            height: 28px;
            padding-left: 16px;
            line-height: 28px;
            font-size: 14px;
            border-bottom: 1px solid #e6e8f2;
            background: #fff;
          }
          .item-wrap {
            font-size: 14px;
            border-bottom: 1px solid #e6e8f2;
            display: flex;
            padding: 12px 0 12px 0;
            align-items: center;
            @apply tw-text-common-black tw-cursor-pointer;
          }
          .name {
            flex: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            padding-left: 16px;
          }
          .name:hover {
            display: block;
          }
          .price {
            width: 104px;
            text-align: right;
            font-size: 14px;
            font-weight: 500;
            padding: 0 16px;
            @apply tw-text-common-red;
          }
          p:hover {
            background: rgb(255, 204, 50, 0.2);
          }
        `}
      </style>
    </section>
  )
}

export default Car
